import React, { useState } from 'react'
import { AddAdvancePayment } from './AddAdvancePayment';
import { AdvancePaymentDetails } from './AdvancePaymentDetails';

export const AdvancePayment = ({masterSaleGroup, code, ref2}) => {
  const [addAdvancePayment, setAddAdvancePayment] = useState(false);

  const [payments, setPayments] = useState(masterSaleGroup.advancePayments);

  return (
    <div style={{marginTop:20}} ref={ref2}>
      <div style={{ fontSize: 20 }}>Anticipos de grupo</div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <button className="btn btn-light btn-icon" style={{ marginTop: 10 }}
          onClick={() => setAddAdvancePayment(true)} >Agregar Anticipo De Grupo</button>
      </div>

      {
        masterSaleGroup.rooms.map((room) => (
          <div style={{marginTop:20}}>
            <div style={{ fontSize: 18 }}>{room.room}</div>
            <AdvancePaymentDetails
              idGroupFile={masterSaleGroup.idGroupFile}
              advancePayments={masterSaleGroup.advancePayments.filter(payment => payment.idRoomMasterSaleGroup === room.id)}
              rooms={masterSaleGroup.rooms}
              services={masterSaleGroup.services}
              code={code} />
          </div>
        ))
      }

      {
        masterSaleGroup.services.map((service) => (
          <div style={{marginTop:20}}>
            <div style={{ fontSize: 18 }}>{service.service}</div>
            <AdvancePaymentDetails
              idGroupFile={masterSaleGroup.idGroupFile}
              advancePayments={masterSaleGroup.advancePayments.filter(payment => payment.idServiceMasterSaleGroup === service.id)}
              rooms={masterSaleGroup.rooms}
              services={masterSaleGroup.services}
              code={code} />
          </div>
        ))
      }

      {
        <div style={{marginTop:20}}>
          <div style={{ fontSize: 18 }}>Anticipos sin concepto</div>
          <AdvancePaymentDetails
            idGroupFile={masterSaleGroup.idGroupFile}
            advancePayments={masterSaleGroup.advancePayments.filter(payment => payment.roomMasterSaleGroup === null && payment.serviceMasterSaleGroup === null)}
            rooms={masterSaleGroup.rooms}
            services={masterSaleGroup.services}
            code={code} />
        </div>
      }        

      <AddAdvancePayment masterSaleGroup={masterSaleGroup} isOpen={addAdvancePayment} setIsOpen={setAddAdvancePayment} />
    </div>
  )
}
